import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Partners } from "./components/partners";
import { Information } from "./components/information";
import { ParallaxImage } from "./components/parallaximage";
import { Contact } from "./components/contact";
import { VideoBird } from "./components/videobird";
import { ProductParallax } from "./components/productParallax";
import { Scenario1 } from "./components/Scenario1";
import { Scenario2 } from "./components/Scenario2";
import { Scenario3 } from "./components/Scenario3";
import { Executive } from "./components/Executive";
import { Problem } from "./components/Problem";
import { ProductScreenLight } from "./components/ProductScreenLight";
import { ProductScreenDark } from "./components/ProductScreenDark";
import { ProductWatch } from "./components/ProductWatch";
import { RadioSection } from "./components/RadioSection";
import { Product } from "./components/product";
import { ChatButton } from "./components/chatButton";
import { LoginUser } from "./components/LoginUser";
import { HomeUser } from "./components/HomeUser";
import { HomeNOK } from "./components/HomeNOK";
import { UserAccess } from "./components/userAccess";
import { AuthProvider } from "./context/AuthContext";
import { AuthProviderNOK } from "./context/AuthContextNok"; // 🚀 Nuevo contexto de NOK
import { AddNameNok } from "./components/AddNameNok";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const availableLanguages = ["en", "es", "no", "ar", "ru", "uk"]; // Idiomas disponibles

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    // 🔹 Detectar idioma del navegador o recuperar del localStorage
    const savedLanguage = localStorage.getItem("selectedLanguage");
    const browserLang = navigator.language.split("-")[0]; // Tomamos solo el código del idioma

    if (savedLanguage && availableLanguages.includes(savedLanguage)) {
      setLanguage(savedLanguage);
    } else if (availableLanguages.includes(browserLang)) {
      setLanguage(browserLang);
      localStorage.setItem("selectedLanguage", browserLang); // Guardamos la preferencia
    }
  }, []);

  useEffect(() => {
    const loadLanguageData = async (lang) => {
      try {
        const data = await import(`./data/data_${lang}.json`);
        setLandingPageData(data.default);
      } catch (error) {
        console.error("Error loading language data:", error);
      }
    };

    if (language) {
      loadLanguageData(language);
    }
  }, [language]);

  return (
    <Router>
      {/* La navegación siempre está disponible */}
      <Navigation data={landingPageData.Navigation} onLanguageChange={setLanguage} />

      <Switch>
        {/* Secciones públicas (sin autenticación) */}
        <Route exact path="/">
          <>
            <Header data={landingPageData.Header} />
            <UserAccess data={landingPageData.UserAccess} />
            <About data={landingPageData.About} />
            <VideoBird data={landingPageData.ViddeoSection} />
            <Services data={landingPageData.Services} />
            <ParallaxImage imageUrl="/img/site_01.jpg" />
            <Information data={landingPageData.Information} />
            <ParallaxImage imageUrl="/img/site_02.jpg" />
            <Gallery data={landingPageData.Gallery} />
            <div className="section-title" style={{ background: "#fff", marginBottom: "0px", height: "100px" }}>
              <h2 style={{ textAlign: "center", margin: "0px" }}>
                {landingPageData.ProductTitle || "Features"}
              </h2>
            </div>

            <ProductParallax imageUrl="/img/product1.png" imageUrlSmall="/img/productSmall1.png" data={landingPageData.ProductWatchScreen} />
            <ProductParallax imageUrl="/img/product2.png" imageUrlSmall="/img/productSmall2.png" data={landingPageData.ProductWatchScreenExtra} />
            <ProductParallax imageUrl="/img/product3.png" imageUrlSmall="/img/productSmall3.png" data={landingPageData.ProductWatch} />
            <ProductParallax imageUrl="/img/product4.png" imageUrlSmall="/img/productSmall4.png" data={landingPageData.ProductScreen} />
            <Partners data={landingPageData.Partners} />
            <ChatButton data={landingPageData.ChatButton} />
            <Contact data={landingPageData.Contact} />
          </>
        </Route>

        <Route path="/product/:id">
          <Product data={landingPageData} />
        </Route>
        <Route path="/b2b">
          <Header data={landingPageData.Header} />
          <Scenario1 data={landingPageData.Scenario1} />
          <Scenario2 data={landingPageData.Scenario2} />
          <Scenario3 data={landingPageData.Scenario3} />
          <Executive data={landingPageData.Executive} />
          <Problem data={landingPageData.Problem} />
          <ProductScreenLight data={landingPageData.ProductScreenLight} />
          <ProductScreenDark data={landingPageData.ProductScreenDark} />
          <ProductWatch data={landingPageData.ProductWatchInfo} />
          <RadioSection data={landingPageData.RadioSection} />
        </Route>
        <Route path="/addNameNok">
          <AddNameNok />
        </Route>

        {/* 🚀 Sección protegida con ambos AuthProviders (User & NOK) */}
        <AuthProvider>
          <AuthProviderNOK> 
            <Route path="/loginUser">
              <LoginUser />
            </Route>

            <Route path="/homeUser">
              <HomeUser />
            </Route>

            <Route path="/homeNOK">
              <HomeNOK />
            </Route>
          </AuthProviderNOK>
        </AuthProvider>
      </Switch>
    </Router>
  );
};

export default App;
